import { useEffect } from 'react';

/** The attributes a component may set on `<html>`; see tokens.css for each. */
export type DocumentFlag = 'data-bottom-nav';

/**
 * Sets `<html NAME>` while `active`, and removes it on unmount.
 *
 * This is how a component tells CSS outside its own subtree that it exists —
 * the bottom tab bar flips `--bottom-nav-offset` for every fixed overlay in
 * the app this way. Kept to a closed union so nobody grows a second, ad-hoc
 * channel of global attributes.
 */
export function useDocumentFlag(name: DocumentFlag, active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    const root = document.documentElement;
    root.setAttribute(name, '');
    return () => {
      root.removeAttribute(name);
    };
  }, [name, active]);
}
